import { render, staticRenderFns } from "./UserLimitElements.vue?vue&type=template&id=66943a0c"
import script from "./UserLimitElements.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLimitElements.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports